import { OmitStrict } from "@amx/ux-twoui-utils";
import { Stack as FluentStack } from "@fluentui/react";
import React from "react";
import { Hyperlink, HyperlinkProps, RoutelinkProps } from "../../../../Links/Hyperlink/Hyperlink";
import { NoHrefLink, NoHrefLinkProps } from "../../../../Links/NoHrefLink/NoHrefLink";
import { StopPropagation } from "../../../../StopPropagation/StopPropagation";
import { enterKeyStopPropagation } from "../props";
import { linkWrapperStyles } from "./DrawerHeaderLink.styles";

export interface DrawerHeaderLinkBaseProps {
    /**
     * Whether to use an ellipsis for long links
     */
    readonly showDrawerLinkEllipsis?: boolean;
}

export interface DrawerHeaderHyperlinkProps extends DrawerHeaderLinkBaseProps {
    readonly kind: "hyperlink";
    /**
     * Hyperlink to render in the drawer header
     */
    readonly hyperlink: OmitStrict<HyperlinkProps, "truncatedLinkProps">;
}

export interface DrawerHeaderRoutelinkProps extends DrawerHeaderLinkBaseProps {
    readonly kind: "routelink";
    /**
     * Routelink to render in the drawer header
     */
    readonly routelink: OmitStrict<RoutelinkProps, "truncatedLinkProps">;
}

export interface DrawerHeaderNoHrefLinkProps extends DrawerHeaderLinkBaseProps {
    readonly kind: "nohreflink";
    /**
     * NoHrefLink to render in the drawer header
     */
    readonly nohreflink: OmitStrict<NoHrefLinkProps, "truncatedLinkProps">;
}

export type DrawerHeaderLinkProps = DrawerHeaderHyperlinkProps | DrawerHeaderRoutelinkProps | DrawerHeaderNoHrefLinkProps;

export const DrawerHeaderLink: React.FC<DrawerHeaderLinkProps> = ({
    kind,
    showDrawerLinkEllipsis = true,
    ...otherProps
}) => {

    let drawerLink = <></>;
    const ellipsisProps = showDrawerLinkEllipsis ? { truncatedLinkProps: {} } : undefined;

    switch (kind) {
        case "hyperlink":
            drawerLink = <Hyperlink {...otherProps["hyperlink"]} {...ellipsisProps} />;
            break;
        case "routelink":
            drawerLink = <Hyperlink {...otherProps["routelink"]} {...ellipsisProps} />;
            break;
        case "nohreflink":
            drawerLink = <NoHrefLink {...otherProps["nohreflink"]} {...ellipsisProps} />;
            break;
    }

    return (
        <StopPropagation keycodes={[enterKeyStopPropagation]}>
            <FluentStack styles={linkWrapperStyles}>
                {drawerLink}
            </FluentStack>
        </StopPropagation>
    );
};
